import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminMunicipalitiesCount = z.any()
export type TagsGetAdminMunicipalitiesCount = z.infer<typeof tagsGetAdminMunicipalitiesCount>

export const responseGetAdminMunicipalitiesCount = z.object({ "payload": z.object({ "count": z.number() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminMunicipalitiesCount = z.infer<typeof responseGetAdminMunicipalitiesCount>

interface IGetAdminMunicipalitiesCount extends BaseMethodType {
  tags: TagsGetAdminMunicipalitiesCount,
  response: ResponseGetAdminMunicipalitiesCount
}
export const URL = '/admin/municipalities/count'
export const validation = {
  get: {
    tags: tagsGetAdminMunicipalitiesCount,
    response: responseGetAdminMunicipalitiesCount
  }
}
export interface AdminMunicipalitiesCount extends BaseRouteType {
  get: IGetAdminMunicipalitiesCount
}